import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import Logo from "@/components/brand/Logo";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark-marketing grain min-h-screen flex items-center justify-center px-6" data-testid="reset-password-page">
      <div className="absolute top-6 left-6">
        <Link to="/"><Logo variant="light" /></Link>
      </div>
      <div className="w-full max-w-md glass rounded-sm p-8">
        <p className="editorial-overline">Reset password</p>
        <h1 className="font-serif text-3xl text-ivory-50 mt-3">Set a new password</h1>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-ivory-200/60">Reset token</label>
            <input
              data-testid="reset-token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required
              className="mt-2 w-full bg-transparent border border-ivory-200/20 px-4 py-3 text-ivory-50 rounded-sm focus:border-gold-500 outline-none font-mono text-xs"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-ivory-200/60">New password (min 6 chars)</label>
            <input
              data-testid="reset-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-2 w-full bg-transparent border border-ivory-200/20 px-4 py-3 text-ivory-50 rounded-sm focus:border-gold-500 outline-none"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-ivory-200/60">Confirm new password</label>
            <input
              data-testid="reset-confirm"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              className="mt-2 w-full bg-transparent border border-ivory-200/20 px-4 py-3 text-ivory-50 rounded-sm focus:border-gold-500 outline-none"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="reset-submit"
            className="w-full bg-gold-500 hover:bg-gold-400 disabled:opacity-50 text-navy-900 font-semibold rounded-sm py-3 mt-2 transition-colors"
          >
            {loading ? "Updating…" : "Update password"}
          </button>
        </form>
        <p className="text-xs text-ivory-200/60 mt-6">
          Remembered it? <Link to="/login" className="text-gold-500">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
